import { create } from 'zustand';

interface Modal {
  id: string;
  component: React.ComponentType<any>;
  props?: Record<string, any>;
}

interface Toast {
  id: string;
  message: string;
  type: 'success' | 'error' | 'info' | 'warning';
  duration?: number;
}

interface UIState {
  modals: Modal[];
  toasts: Toast[];
  isLoading: boolean;
  loadingMessage?: string;
  
  showModal: (modal: Omit<Modal, 'id'>) => string;
  hideModal: (id: string) => void;
  hideAllModals: () => void;
  
  showToast: (toast: Omit<Toast, 'id'>) => void;
  hideToast: (id: string) => void;
  
  setLoading: (isLoading: boolean, message?: string) => void;
}

export const useUIStore = create<UIState>((set, get) => ({
  modals: [],
  toasts: [],
  isLoading: false,
  loadingMessage: undefined,

  showModal: (modal) => {
    const id = `modal-${Date.now()}`;
    set((state) => ({
      modals: [...state.modals, { ...modal, id }],
    }));
    return id;
  },

  hideModal: (id) => {
    set((state) => ({
      modals: state.modals.filter((modal) => modal.id !== id),
    }));
  },

  hideAllModals: () => {
    set({ modals: [] });
  },

  showToast: (toast) => {
    const id = `toast-${Date.now()}`;
    const duration = toast.duration || 3000;
    
    set((state) => ({
      toasts: [...state.toasts, { ...toast, id }],
    }));
    
    if (duration > 0) {
      setTimeout(() => {
        get().hideToast(id);
      }, duration);
    }
  },

  hideToast: (id) => {
    set((state) => ({
      toasts: state.toasts.filter((toast) => toast.id !== id),
    }));
  },

  setLoading: (isLoading, message) => {
    set({ isLoading, loadingMessage: message });
  },
}));